:host {
  overflow: hidden;
}

#licenses-container {
  margin: calc(var(--spacer) * 2) 0;
  display: flex;
  flex: 1;
  width: 100%;
  flex-wrap: wrap;

  .license-item {
    margin-right: var(--spacer);
    margin-bottom: var(--spacer);
    width: max-content;
    height: min-content;
    visibility: hidden;
  }

  #viewAllButton {
    margin: 0 0 var(--spacer) 0;
  }
}

.loading-container {
  margin-top: calc(var(--spacer) * 2);
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 7);
  width: 100%;

  .loading-section {
    display: flex;
    flex-direction: column;
    gap: var(--spacer);
    width: 100%;
  }
}

gz-info-box {
  --info-box-width: 100%;
  --info-box-message-width: calc(100% - var(--spacer) * 7);
}
